import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styles"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 19v2H7l4.46-11.6c.3578-.92495.5409-1.90825.54-2.9 0-.39782-.158-.77936-.4393-1.06066C11.2794 5.15804 10.8978 5 10.5 5c-.3978 0-.77936.15804-1.06066.43934C9.15804 5.72064 9 6.10218 9 6.5V8H7V6.5c0-.92826.36875-1.8185 1.02513-2.47487C8.6815 3.36875 9.57174 3 10.5 3c.9283 0 1.8185.36875 2.4749 1.02513C13.6313 4.6815 14 5.57174 14 6.5c.0009.99175-.1822 1.97505-.54 2.9L9.771 19H14zM6.00098 3.00098V21.001h-2.01l.027-15.00002-2.017 1 .017-2 3.983-2zM21.7238 9.35762c.1821-.42946.276-.89115.2762-1.35762V6.5c-.0045-.92688-.3747-1.81452-1.0301-2.46994C20.3145 3.37465 19.4269 3.00447 18.5 3c-.9283 0-1.8185.36875-2.4749 1.02513C15.3687 4.6815 15 5.57174 15 6.5V8h2V6.5c0-.39782.158-.77936.4393-1.06066C17.7206 5.15804 18.1022 5 18.5 5c.3978 0 .7794.15804 1.0607.43934S20 6.10218 20 6.5V8c0 .39782-.158.77936-.4393 1.06066-.2813.2813-.6629.43934-1.0607.43934H17v2h1.5c.3978 0 .7794.158 1.0607.4393S20 12.6022 20 13v4.5c0 .3978-.158.7794-.4393 1.0607S18.8978 19 18.5 19c-.3978 0-.7794-.158-1.0607-.4393S17 17.8978 17 17.5V16h-2v1.5c.0045.9269.3747 1.8145 1.0301 2.4699S17.5731 20.9955 18.5 21c.9283 0 1.8185-.3687 2.4749-1.0251C21.6313 19.3185 22 18.4283 22 17.5V13c.0021-.4668-.0907-.9292-.273-1.359-.1822-.4298-.45-.818-.787-1.141.3352-.3244.6017-.71291.7838-1.14238z",
    fill: "currentColor"
  }));
});